<template lang="pug">
portal(selector="#search" class="portal")
    v-app-bar(
        flat
        color="#fff"
        class="suus__search-bar"
        :height="58"
    )
        QuickSearch
</template>

<script lang="ts">
import Vue from "vue"
import QuickSearch from "../../components/QuickSearch.vue"

export default Vue.extend({
  name: "PortalSearch",
  components: { QuickSearch },
})
</script>

<style lang="sass">
.suus__search-bar
    height: 58px !important
    padding: 0
</style>
